export enum requestType  {
  ping = 1,
  login = 2,
  pushMessage =3,
  getMessage = 4,
  removeMessage = 7,
  getGroupMessage = 5,
  getGroupUserList = 6,
  getGroupMenuTree = 8,
}

export enum messageType  {
  text,
  picture,
  file,
  voice,
  video,
  groupChange,
  papa,
  recall,
  groupInfo,
  other,//其他
  homework,//作业
}

export enum upgradeGroupType {
  addUser = 0,
  removeUser,
  changeName,
  changeAvatar,
  changeAdmin,
  changeGroupPostMessage,
  changeGroupAuth,
}

export interface group {
  id?: string,
  systemId?: string,
  p2p?:string,
  name: string,
  avatar?: string,
  memberNum?:number,
  adminUid?:string,
  announcement: string,
  authChangeName: 0|1,
  authChangeAnnounce: 0|1,
  authInviteUser: 0|1,
  createTime?:number,
  updateTime?:number,
  userList?: Array<user>,
  updateType?: upgradeGroupType,
  // 课程名
  remark: string
}

export interface user {
  uid:number,
  systemId?:number;
  systemUid?:number;
  name?:string;
  avatar?:string;
  remark?:string;
  createTime?:number;
  updateTime?:number;
  mute?:number;
}

export interface groupUser extends user {
  groupId: number,
  p2p: 0 | 1, // 0 群聊 1 单聊
  lastAckMsgId: number, // 最后一次确认信息的id
  lastMsgId: number, // 最新的消息id
  unReadCount: 1, // 未读数量
  silence: 0 | 1, // 是否静音
  top: 0 | 1, // 是否置顶
  valid: 0 | 1, // 0.无效1.有效 删除后无效，只能看，不能发布消息
  invalidTime: number,
  deleteTime: number,
}

export interface message {
  id?: number;
  groupId:number;
  systemId?:number;
  fromUid:number;
  end?:number;
  msgType:messageType,
  notifyUserArray?:Array<number>;
  fileUrl?: string;
  msgContent: string;
  createTime:number;
  updateTime?:number;
  uniqueCode?:number;//返回码
  msgtatus?:number;//消息状态
}

export interface GroupMessage extends message {
  user?: user,
}

export interface FirstPageInfoItem {
  lastMsgUserName: string,
  groupUser: groupUser,
  lastMsg: message,
  group: group,
  systemUid: string
}

export interface requestData<payloadType> {
  requestType: requestType,
  uniqueCode: number,
  payload?: payloadType,
}

export interface responseData<payloadType> extends requestData<payloadType> {
  returnCode: number,
  returnMsg: string,
}

export declare namespace requestPayload {
  type ping = null;
  type login = {
    uid: number | string,
    imToken: number | string,
    deviceId: number | string,
    pageCurrent: number,
    pageSize: number,
  }
  type pushMessage = {
    id?: string,  // = messageId 消息的id ，如果有id代表更改消息，没有id代表新增消息
    groupId: number,
    msgType: messageType,
    notifyUserArray: Array<number>,
    msgContent: string,
    updateGroupDto?: group, // 组变更的消息（添加管理人员等）
    fileUrl?: string,
  }
  type getGroupMessage = {
    groupId:number,
    msgId?:number,
    pageSize?:number,
  }
  type getGroupUserList = {
    groupId:number,
  }
  type removeMessage = {
    groupId: number,
  }
  type setAlreadyRead = {
    groupId: number,
    id: number,
    msgType: number,
  }
}

export declare namespace responsePayload{
  type ping = null;
  type login = {
    data: Array<FirstPageInfoItem>,
    total: number,
  }
  type pushMessage = {
    msgId: number,
  }
  // type getMessage = {
  //   id?: string,  // = messageId 消息的id ，如果有id代表更改消息，没有id代表新增消息
  //   groupId: number,
  //   msgType: messageType,
  //   notifyUserArray: Array<number>,
  //   msgContent: string,
  //   updateGroupDto: group,
  //   fileUrl: string,
  //   name: string,
  //   avatar: string,
  //   fromUid: number,
  //   createTime: number,
  // }
  type getMessage = message;
  type removeMessage = null;
  type getGroupMessage =  {
    data: Array<GroupMessage>
  }

  type getGroupUserList = {
    groupInfo: group,
    userList: Array<user>,
  }
}

/**
 * websocket instance initial options.
 * @namespace ImOptionConfig - 实例配置选项
 * @property {String} [url] - url
 * @property {Function} onLogin - 首次登录的回掉函数
 * @property {Function} onUpdateMessage - 有消息推过来更新消息的回掉函数
 * @property {Function} onGrouped - 分组成功的回掉
 * @property {Function} onOpen - websocket 原生 onopen 回掉
 * @property {Function} onMessage - websocket 原生 onmessage 回掉
 * @property {Function} onError - websocket 原生 onerror 回掉
 * @property {Function} onClose  - websocket 原生 onclose 回掉
 */
export interface d{}
export interface ImOptionConfig {
  url?: string,
  onLogin?:(data: string) => any,
  onUpdateMessage?: (data: object) => any,
  onGrouped?: (message:message) => any,

  // 以下是 原生websocket 事件勾子
  onOpen?:(e:Event | string) => any,
  onMessage?: (e:MessageEvent | string) => any,
  onError?: (e:Event | string) => any,
  onClose?: (e:CloseEvent | string) => any,
}

export interface MessageMap {
  [key: string] : {
    createTime: number,
    messageData: requestData<any>,
  }
}
